import { render, staticRenderFns } from "./M2hActivateConfirm.vue?vue&type=template&id=0795b226&scoped=true&"
import script from "./M2hActivateConfirm.vue?vue&type=script&lang=js&"
export * from "./M2hActivateConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0795b226",
  null
  
)

export default component.exports